// extracted by mini-css-extract-plugin
export default {"Backdrop":"Backdrop_Backdrop__vpHqN","Dark":"Backdrop_Dark__YHdJh"};